<template>
<div class="map-leaflet" ref="map-leaflet"></div>
</template>

<script>

export default {
props: {
	geoDetails: {
		type : [Array],
		required: false
	},
	mapOptions:{
		type: Object,
		required:false,
		default:()=>{
			return {zoomControl: true,scrollWheelZoom: true}
		}
	}
},
data(){
	return {
		map:null,
		markers:[],
		polygons:[],
		labelMarkers:[]
	}
},
computed: {

},
methods: {
	addMarker(model){
		let marker = window.L.marker([model.latitude,model.longitude]).addTo(this.map);
		marker.bindPopup("<b>"+model.title+"</b><br>"+model.details+"").openPopup();
		setTimeout(() => {
			marker.closePopup();
		}, 0);
	},
	addPolygon(model){
		let polygon = window.L.polygon(model.geoPoints).addTo(this.map);
		//polygon.bindPopup(model.title+"<br> <a href='google.com'></a>");
		let text = " "+model.title+" <br>"+model.details
		polygon.bindPopup(text);

		// Add the label marker to the map
		// Calculate the centroid of the polygon for placing the label
		// Create a custom marker with a label using a divIcon
		let name = model.title;
		try{
			name = name.slice(0, 25);
			name+=(name.length === model.title.length)?'':'...'
		}catch(err){
			name = model.title;
		}

		let label = window.L.divIcon({
			className: 'polygon-label', // Add custom styling here
			html: `<div>${name}</div>`
		});

		let centroid      = this.calculateCentroid(model.geoPoints);
		let labelMarker   = window.L.marker(centroid, { icon: label }).addTo(this.map);
		this.labelMarkers.push(labelMarker);
		return polygon;
	},

	drawZones(zoneModels){
		this.polygons.forEach(polygon => {
			this.map.removeLayer(polygon);
		});
		this.labelMarkers.forEach(labelMarker => {
			this.map.removeLayer(labelMarker);
		});
		zoneModels.forEach((zoneModel)=>{
			let arrGeopoints= zoneModel.zoneGeoPoints.map((item)=>{
				return [parseFloat(item.latitude),parseFloat(item.longitude)];
			})
			let modelPoly ={
				geoPoints:arrGeopoints,
				title:zoneModel.name,
				details:""
			}
			let polygon = this.addPolygon(modelPoly)
			this.polygons.push(polygon);
		})


		setTimeout(() => {
			if (this.map && this.polygons.length > 0) {
				let allBounds = window.L.latLngBounds(this.polygons[0].getBounds());
				this.polygons.forEach((polygon) => {
					allBounds.extend(polygon.getBounds());
				});
				this.map.fitBounds(allBounds);
			}
		}, 0);
	},
	calculateCentroid(points) {
		let centroid = [0, 0];
		let signedArea = 0.0;
		let x0 = 0.0; // Current vertex X
		let y0 = 0.0; // Current vertex Y
		let x1 = 0.0; // Next vertex X
		let y1 = 0.0; // Next vertex Y
		let a = 0.0;  // Partial signed area

		for (let i = 0; i < points.length - 1; ++i) {
		x0 = points[i][0];
		y0 = points[i][1];
		x1 = points[i + 1][0];
		y1 = points[i + 1][1];
		a = x0 * y1 - x1 * y0;
		signedArea += a;
		centroid[0] += (x0 + x1) * a;
		centroid[1] += (y0 + y1) * a;
		}

		x0 = points[points.length - 1][0];
		y0 = points[points.length - 1][1];
		x1 = points[0][0];
		y1 = points[0][1];
		a = x0 * y1 - x1 * y0;
		signedArea += a;
		centroid[0] += (x0 + x1) * a;
		centroid[1] += (y0 + y1) * a;

		signedArea *= 0.5;
		centroid[0] /= (6.0 * signedArea);
		centroid[1] /= (6.0 * signedArea);

		return centroid;
	},
	setGeoDetailsRides(arr){
			arr.forEach(element => {
				try{
					let modelMarker = {
						latitude: element.pickup.geo.latitude,
						longitude: element.pickup.geo.longitude,
						title: "Pickup",
						details: element.pickup.title
					};
					this.addMarker(modelMarker);
					modelMarker = {
						latitude: element.dropoff.geo.latitude,
						longitude: element.dropoff.geo.longitude,
						title: "Dropoff",
						details: element.dropoff.title
					}
					this.addMarker(modelMarker);
					
					
					element.zonesNearest.forEach(_zone=>{
						let arrGeopoints= _zone.polygon.map((item)=>{
							return [parseFloat(item.latitude),parseFloat(item.longitude)];
						})
						let linkToRp ="<small> <a href='/rate-plans-edit?id="+(_zone.ratePlanId??0)+"' target='_blank'> Ir al rate plan </a></small>"
						let modelPoly ={
							geoPoints:arrGeopoints,
							title:"<b>Zone Name</b>: "+_zone.zoneName,
							details:"<b>Rate Plan</b>: "+_zone.ratePlanName+"<br>"+linkToRp
						}
						this.addPolygon(modelPoly)
					})
				}catch(err){
					console.log(err)
				}
			});
			setTimeout(() => {
				this.map.setZoom(9);
			}, 0);
		}
},
mounted(){
	this.map = window.L.map(this.$refs["map-leaflet"],this.mapOptions).setView([51.505, -0.09], 13);
	window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
		maxZoom: 19,
		attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	}).addTo(this.map);
	setTimeout(()=>{
		this.map.invalidateSize();
	}, 10);

	if(!this.$root.isEmpty(this.geoDetails)){
		this.setGeoDetailsRides([...this.geoDetails])
	}
}

}
</script>

<style>
.map-leaflet { height: 400px; }

.polygon-label{
	color:#000;
	max-width: 200px !important;
	min-width: 100px !important;
	width: auto !important;
	font-size: 12px;
}
</style>
